import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";
import {
  SMALL_VIEWPORT,
  MEDIUM_VIEWPORT
} from "../../../state/modules/layout/constants";
import { navigationPropType } from "../../../state/modules/navigation";
import { MALE, FEMALE, genderPropType } from "../../../state/modules/layout";
import FloorNavigation from "../../FloorNavigation";
import SidePrimaryNavigation from "../SidePrimaryNavigation";
import SideSecondaryNavigation from "../SideSecondaryNavigation";
import withTranslation from "../../translation";
import withViewport from "../../Viewport/withViewport";
import Footer from "../../Footer";
import styles from "./index.css";

const cx = classnames.bind(styles);

class SidePanel extends PureComponent {
  shouldAnimate = false;

  constructor(props) {
    super(props);

    this.saveDialog = this.saveDialog.bind(this);
    this.getCloseButtonRef = this.getCloseButtonRef.bind(this);
  }

  componentDidUpdate({ isSidePanelOpen }) {
    if (this.props.isSidePanelOpen !== isSidePanelOpen && this.closeButton) {
      this.closeButton.focus();
    }
  }

  componentDidMount() {
    this.dialog.addEventListener("transitionend", this.handleTransitionEnd);
  }

  componentWillUnmount() {
    this.dialog.removeEventListener("transitionend", this.handleTransitionEnd);
  }

  handleTransitionEnd = ({ target, currentTarget }) => {
    this.triggerRedraw();
    if (target === currentTarget) {
      this.props.clearNavActiveItem();
    }
  };

  triggerRedraw() {
    this.dialog.style.display = "none";
    this.dialog.offsetHeight;
    this.dialog.style.display = "block";
  }

  saveDialog(c) {
    this.dialog = c;
  }

  getCloseButtonRef(c) {
    this.closeButton = c;
  }

  render() {
    const {
      formatTranslation,
      isSidePanelOpen,
      isVisible,
      closeSidePanel,
      navActiveItem,
      setNavActiveItem,
      clearNavActiveItem,
      currentGender,
      maleItems,
      femaleItems
    } = this.props;
    this.shouldAnimate = this.shouldAnimate || (isSidePanelOpen && isVisible);

    const navProps = {
      currentGender,
      navActiveItem,
      setNavActiveItem,
      clearNavActiveItem
    };

    return (
      <div>
        <div
          role="dialog"
          aria-label={formatTranslation("sidepanel_navigation_label")}
          aria-hidden={!isSidePanelOpen}
          ref={this.saveDialog}
          className={cx(styles.dialog, {
            [styles.dialog__visible]: isSidePanelOpen && isVisible,
            [styles.dialog__animate]: this.shouldAnimate
          })}
          data-testid="sidepanel"
        >
          <div className={styles.container}>
            <button
              className={styles.close}
              onClick={closeSidePanel}
              aria-label={formatTranslation("sidepanel_close_navigation_label")}
              ref={this.getCloseButtonRef}
              data-testid="close-button"
            />
            <div className={styles.dontHideButtonContainer}>
              <div
                className={cx(styles.primarySideContainer, {
                  [styles.primarySideContainer__hidden]: !!navActiveItem,
                  [styles.primarySideContainer__animate]: this.shouldAnimate
                })}
              >
                <FloorNavigation viewable={[SMALL_VIEWPORT, MEDIUM_VIEWPORT]} />
                <div className={styles.content}>
                  <SidePrimaryNavigation
                    {...navProps}
                    items={femaleItems}
                    forGender={FEMALE}
                  />
                  <SidePrimaryNavigation
                    {...navProps}
                    items={maleItems}
                    forGender={MALE}
                  />
                  <Footer isAccordion={true} />
                </div>
              </div>
              <SideSecondaryNavigation
                {...navProps}
                items={femaleItems}
                forGender={FEMALE}
              />
              <SideSecondaryNavigation
                {...navProps}
                items={maleItems}
                forGender={MALE}
              />
            </div>
          </div>
        </div>
        <aside
          className={cx(styles.overlay, {
            [styles.overlay__show]: isSidePanelOpen && isVisible,
            [styles.overlay__animate]: this.shouldAnimate
          })}
          role="button"
          onClick={closeSidePanel}
          onTouchMove={event => {
            event.preventDefault();
            return false;
          }}
          aria-hidden="true"
        />
      </div>
    );
  }
}

SidePanel.propTypes = {
  isSidePanelOpen: PropTypes.bool.isRequired,
  closeSidePanel: PropTypes.func.isRequired,
  clearNavActiveItem: PropTypes.func.isRequired,
  setNavActiveItem: PropTypes.func.isRequired,
  navActiveItem: PropTypes.string,
  currentGender: genderPropType.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  isVisible: PropTypes.bool,
  maleItems: PropTypes.arrayOf(navigationPropType).isRequired,
  femaleItems: PropTypes.arrayOf(navigationPropType).isRequired
};

export default withViewport(withTranslation(SidePanel));
